<template>
    <div>
        <v-layout row wrap v-if="isHired">
            <v-flex xs10 lg8 offset-xs1 offset-lg2>
                <v-card class="pa-2">
                    <v-card-text>
                        <v-layout row>
                            <v-flex xs10>
                                <p class="subheading ma-0" style="font-weight:500">Avaliação das Demandas</p>
                                <p class="grey--text text--darken-1 ma-0">Visualiza as informações sobre a avaliação das demandas das Secretarias.</p>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-btn @click="manageScoreOffices" style="margin-top:15px">
                                Acessar
                            </v-btn>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>

export default {
    data() {
        return {
        };
    },

    computed: {
        isHired() {
            return this.$store.getters.profile.person.isHired;
        },
    },

    methods: {
        manageScoreOffices() {
            this.$router.push({ name: 'officeScoreIndex' });
        },
    },
};
</script>




// WEBPACK FOOTER //
// src/components/prodam/Index.vue